export default "__VITE_ASSET__c7606ad9__"